import { storyblokEditable } from '@storyblok/react/rsc';
import PhosphorIcon from '@/components/PhosphorIcon';

const sizeMap = { '16': 16, '20': 20, '24': 24, '32': 32, '40': 40, '48': 48, '64': 64 };

const Icon = ({ blok }) => {
  if (!blok.icon) return null;

  return (
    <div {...storyblokEditable(blok)}>
      <PhosphorIcon
        name={blok.icon}
        size={sizeMap[blok.size] || 32}
        color={blok.color || undefined}
        weight={blok.weight || 'regular'}
      />
    </div>
  );
};

export default Icon;
